import script from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=2cdb1c02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdb1c02"]])

export default __exports__